/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { Header, LoginHeader } from "../../components/Header";
import UserContext from "../../context/User";
import Analytics from "../../utils/analytics";
import useStyle from "./styles";
import Seo from "../../components/Seo/Seo";

function Section({ title, children, classes }) {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="subtitle2" className={classes.boldText} sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1.5 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function P({ children, classes }) {
  return (
    <Typography variant="subtitle2" className={classes.MV2} sx={{ lineHeight: 1.7 }}>
      {children}
    </Typography>
  );
}

function Bullets({ items, classes }) {
  return (
    <ul className={classes.bullet}>
      {items.map((item, i) => (
        <li key={i}>
          <Typography variant="subtitle2" sx={{ lineHeight: 1.7 }}>{item}</Typography>
        </li>
      ))}
    </ul>
  );
}

function Terms() {
  useEffect(() => {
    Analytics.track(Analytics.events.NAVIGATE_TO_TERMS);
  }, []);
  const classes = useStyle();
  const { isLoggedIn } = useContext(UserContext);

  return (
    <Grid className={classes.root}>
      <Seo
        title="Terms of Use"
        description="The terms and conditions that apply when you order food, arrange delivery or pickup, and use the RushMyFood site and apps."
        path="/terms"
      />
      {isLoggedIn ? <Header /> : <LoginHeader showIcon />}
      <Grid container className={classes.mainContainer}>
        <Box className={classes.imageContainer}>
          <Typography variant="h4" component="h1" color="textPrimary" align="center" className={classes.title}>
            TERMS OF USE AGREEMENT
          </Typography>
        </Box>
        <Grid container item xs={12} className={classes.mainContainer}>
          <Grid item xs={1} md={1} />
          <Grid container item xs={10} sm={10} md={9}>
            <Box>
              <P classes={classes}>
                This Terms of Use Agreement (“Agreement”) constitutes a legally binding agreement made between you,
                whether personally or on behalf of an entity (“user” or “you”) and RushMyFood, LLC (DBA rushmyfood.com)
                and its affiliated companies (collectively, the “Rushmyfood” or “we” or “us” or “our”), concerning your
                access to and use of the www.Rushmyfood.com website as well as any other media form or media channel
                related or connected thereto (collectively, the “Website”). The Website allows restaurants
                (“Restaurants”) to market and offer for sale meals for delivery and/or pick up and customers to search
                for and purchase such meals (“Rushmyfood Services”). The Rushmyfood Services are hosted in the United
                States.
              </P>
              <P classes={classes}>
                All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must
                have the permission of, and be directly supervised by, their parent or guardian to use the Website. If
                you are a minor, you must have your parent or guardian read and agree to this Agreement prior to you
                using the Website. Persons under the age of 13 are not permitted to register for the Website or use
                the Website Services.
              </P>
              <P classes={classes}>
                YOU ACCEPT AND AGREE TO BE BOUND BY THIS AGREEMENT BY ACKNOWLEDGING SUCH ACCEPTANCE DURING THE
                REGISTRATION PROCESS (IF APPLICABLE) AND ALSO BY CONTINUING TO USE THE WEBSITE. IF YOU DO NOT AGREE TO
                ABIDE BY THIS AGREEMENT, OR TO MODIFICATIONS THAT RUSHMYFOOD MAY MAKE TO THIS AGREEMENT IN THE FUTURE,
                DO NOT USE OR ACCESS OR CONTINUE TO USE OR ACCESS THE RUSHMYFOOD SERVICES OR THE WEBSITE.
              </P>

              <Section title="Our Purpose" classes={classes}>
                <P classes={classes}>
                  We have created the Website to serve as a marketplace. Rushmyfood is a merchant of food ordering and
                  delivery services. Rushmyfood does not sell or control the production of any food produced at the
                  Restaurants. Rather this marketplace provides buyers the ability to search for and find local
                  Restaurants that deliver or make food available for pick up.
                </P>
                <P classes={classes}>
                  The Restaurants are obligated by Rushmyfood to comply with federal, state and local laws, rules,
                  regulations, and standards pertaining to food preparation, sale, marketing and safety. However, it
                  is critical for users to understand that Rushmyfood does not in any way independently verify the
                  credentials, representations or products of Restaurants, the ingredients or the quality of any
                  products, or that a Restaurant is in compliance with applicable laws. Buyers must make themselves
                  comfortable through information provided by Restaurants on the Website or as requested by buyers
                  directly from the Restaurants as to the quality and reliability of the Restaurants, as well as to
                  their compliance with applicable laws. Rushmyfood does not in any way guaranty the quality of any
                  food or that any food complies with applicable laws. In addition, a Restaurant may represent that
                  food preparation is in accordance with special standards such as “organic,” “kosher,” “macrobiotic”
                  or allergen-specific standards such as “nut-free,” “gluten-free,” or “lactose-free.” However,
                  Rushmyfood does not independently investigate or verify such representations. Rushmyfood shall not
                  be liable or responsible for any food or services offered by Restaurants that is unhealthy, is the
                  cause of injury, that is otherwise unacceptable to buyers or that does not meet the expectation of
                  buyers in any manner. Buyers are solely responsible for verifying the accuracy of delivery
                  addresses, and Rushmyfood shall have no liability or responsibility for any such erroneous
                  addresses.
                </P>
                <P classes={classes}>
                  Please direct all complaints concerning Restaurants to Rushmyfood’s attention as indicated on the
                  Website.
                </P>
              </Section>

              <Section title="Ordering and Payment" classes={classes}>
                <P classes={classes}>
                  All ordering is performed online. Buyers are usually billed directly by Rushmyfood for their orders,
                  and “Rushmyfood” will be the name that appears on your payment records, but Rushmyfood shall not in
                  any manner be considered the seller of the food.
                </P>
              </Section>

              <Section title="Refund Policy" classes={classes}>
                <P classes={classes}>
                  Rushmyfood takes customer satisfaction very seriously. In the case of problems with your food order,
                  please contact the Restaurant directly. If you have not been able to resolve your issue with the
                  Restaurant to your satisfaction, please contact Rushmyfood and we will try to assist you. In
                  appropriate cases, if you have already been billed by Rushmyfood, Rushmyfood will issue full or
                  partial refunds. For example: if you did not receive your order or received an incorrect order, you
                  may be issued a full refund; if part of your order is missing, we may issue a partial refund. In
                  every event, we will do our best to ensure your satisfaction. If you were billed by Rushmyfood.com,
                  Rushmyfood.com will provide a full or partial refund if, for example, you did not receive your food
                  order, or part of your order, on a case to case basis.
                </P>
              </Section>

              <Section title="User Representations" classes={classes}>
                <Typography variant="subtitle2" className={classes.boldText} sx={{ mt: 1 }}>General</Typography>
                <P classes={classes}>By using the Rushmyfood Services, you represent and warrant that:</P>
                <Bullets
                  classes={classes}
                  items={[
                    "all registration information you submit is truthful and accurate;",
                    "you will maintain the accuracy of such information;",
                    "you will keep your password confidential and will be responsible for all use of your password and account;",
                    "you are not a minor in the jurisdiction in which you reside, or if a minor, you have received parental permission to use this Website; and",
                    "your use of the Rushmyfood Services does not violate any applicable law or regulation.",
                  ]}
                />
                <Typography variant="subtitle2" className={classes.boldText} sx={{ mt: 2 }}>Regarding Content You Provide</Typography>
                <P classes={classes}>
                  You are entirely responsible for the content of, and any harm resulting from, your postings to the
                  interactive portions of the Website (“Contribution”). When you create or make available a
                  Contribution, you thereby represent and warrant that:
                </P>
                <Bullets
                  classes={classes}
                  items={[
                    "the creation, distribution, transmission, public display and performance, accessing, downloading and copying of your Contribution does not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret or moral rights of any third party;",
                    "you are the creator and owner of or have the necessary licenses, rights, consents, releases and permissions to use and to authorize Rushmyfood and the Website users to use your Contributions as necessary to exercise the licenses granted by you under this Agreement;",
                    "your Contribution does not contain any viruses, worms, Trojan horses, malicious code or other harmful or destructive content;",
                    "your Contribution is not obscene, lewd, lascivious, filthy, violent, harassing or otherwise objectionable (as determined by Rushmyfood), libelous or slanderous, does not advocate the violent overthrow of the government of the United States, does not incite, encourage or threaten immediate physical harm against another, does not violate any applicable law, regulation, or rule, and does not violate the privacy or publicity rights of any third party;",
                    "your Contribution does not constitute, contain, install or attempt to install or promote spyware, malware or other computer code, whether on Rushmyfood’s or others’ computers or equipment, designed to enable you or others to gather information about or monitor the online or other activities of another party;",
                    "your Contribution does not inundate the Website with communications or other traffic suggesting no serious intent to use the Website for its stated purpose;",
                    "your Contribution does not otherwise violate, or link to material that violates, any provision of this Agreement or any applicable law or regulation; and",
                    "your Contribution does not contain pictures, data, audio or visual files, or any other content that is excessive in size, as determined by Rushmyfood in its sole discretion.",
                  ]}
                />
              </Section>

              <Section title="Contribution License" classes={classes}>
                <P classes={classes}>
                  By posting Contributions to any part of the Website, you automatically grant, and you represent and
                  warrant that you have the right to grant, to Rushmyfood an irrevocable, perpetual, non-exclusive,
                  transferable, royalty-free, fully-paid, worldwide license to use, copy, publicly perform, publicly
                  display, reformat, translate, excerpt (in whole or in part) and distribute such Contributions for
                  any purpose, commercial, advertising, or otherwise, on or in connection with the Website or the
                  promotion thereof, to prepare derivative works of, or incorporate into other works, such
                  Contributions, and to grant and authorize sublicenses of the foregoing.
                </P>
                <P classes={classes}>
                  Rushmyfood has the right, in our sole and absolute discretion, to (i) edit, redact or otherwise
                  change any Contributions, (ii) re-categorize any Contributions to place them in more appropriate
                  locations or (iii) pre-screen or delete any Contributions that are determined to be inappropriate
                  or otherwise in violation of this Agreement.
                </P>
              </Section>

              <Section title="Submissions" classes={classes}>
                <P classes={classes}>
                  You acknowledge and agree that any questions, comments, suggestions, ideas, feedback or other
                  information about the Website or the Rushmyfood Services (“Submissions”) provided by you to
                  Rushmyfood are non-confidential and Rushmyfood (as well as any designee of Rushmyfood) shall be
                  entitled to the unrestricted use and dissemination of these Submissions for any purpose, commercial
                  or otherwise, without acknowledgment or compensation to you.
                </P>
              </Section>

              <Section title="Prohibited Activities" classes={classes}>
                <P classes={classes}>
                  You may not access or use the Website for any other purpose other than that for which Rushmyfood
                  makes it available. The Website is for the personal use of users only and may not be used in
                  connection with any commercial endeavors except those that are specifically endorsed or approved by
                  Rushmyfood. Prohibited activity includes, but is not limited to:
                </P>
                <Bullets
                  classes={classes}
                  items={[
                    "criminal or tortious activity, including child pornography, fraud, trafficking in obscene material, drug dealing, gambling, harassment, stalking, spamming, copyright infringement, patent infringement, or theft of trade secrets;",
                    "advertising to, or solicitation of, any user to buy or sell any products or services, unless authorized by Rushmyfood;",
                    "systematic retrieval of data or other content from the Website to create or compile, directly or indirectly, a collection, compilation, database or directory without written permission from Rushmyfood;",
                    "making any unauthorized use of the Rushmyfood Services, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email;",
                    "engaging in unauthorized framing of or linking to the Website;",
                    "transmitting chain letters or junk email to other users;",
                    "using any information obtained from the Website in order to contact, advertise to, solicit, or sell to any user without their prior explicit consent;",
                    "engaging in any automated use of the system, such as using scripts to add friends or send comments or messages, or using any data mining, robots or similar data gathering and extraction tools;",
                    "interfering with, disrupting, or creating an undue burden on the Website or the networks or services connected to the Website;",
                    "attempting to impersonate another user or person;",
                    "using the username of another user;",
                    "selling or otherwise transferring your profile;",
                    "using any information obtained from the Website in order to harass, abuse, or harm another person;",
                    "using the Rushmyfood Service as part of any effort to compete with Rushmyfood or to provide services as a service bureau;",
                    "deciphering, decompiling, disassembling or reverse engineering any of the software comprising or in any way making up a part of the Website;",
                    "attempting to bypass any measures of the Website designed to prevent or restrict access to the Website, or any portion of the Website;",
                    "harassing, annoying, intimidating or threatening any Rushmyfood employees or agents engaged in providing any portion of the Rushmyfood Services to you;",
                    "displaying an advertisement, or accepting payment or anything of value from a third person in exchange for your performing any commercial activity on or through the Website on behalf of that person, such as posting blogs or bulletins with a commercial purpose;",
                    "deleting the copyright or other proprietary rights notice from any Contribution or Rushmyfood Content; and",
                    "using the Website in a manner inconsistent with any and all applicable laws and regulations.",
                  ]}
                />
              </Section>

              <Section title="Intellectual Property Rights" classes={classes}>
                <P classes={classes}>
                  The content on the Website (“Rushmyfood Content”) and the trademarks, service marks and logos
                  contained therein (“Marks”) are owned by or licensed to Rushmyfood, and are subject to copyright and
                  other intellectual property rights under United States and foreign laws and international
                  conventions. Rushmyfood Content, includes, without limitation, all source code, databases,
                  functionality, software, website designs, audio, video, text, photographs and graphics. All
                  Rushmyfood graphics, logos, designs, page headers, button icons, scripts and service names are
                  registered trademarks, common law trademarks or trade dress of Rushmyfood in the U.S. and/or other
                  countries. Rushmyfood’s trademarks and trade dress may not be used, including as part of trademarks
                  and/or as part of domain names, in connection with any product or service in any manner that is
                  likely to cause confusion and may not be copied, imitated, or used, in whole or in part, without the
                  prior written permission of Rushmyfood. Rushmyfood Content on the Website is provided to you “AS IS”
                  for your information and personal use only and may not be used, copied, reproduced, distributed,
                  transmitted, broadcast, displayed, sold, licensed, or otherwise exploited for any other purposes
                  whatsoever without the prior written consent of the respective owners. Systematic retrieval of data
                  or other content from the Website to create or compile, directly or indirectly, a collection,
                  compilation, database or directory without written permission from Rushmyfood is prohibited.
                  Provided that you are eligible to use the Website, you are granted a limited license to access and
                  use the Website and the Rushmyfood Content and to download or print a copy of any portion of the
                  Rushmyfood Content to which you have properly gained access solely for your personal, non-commercial
                  use. Rushmyfood reserves all rights not expressly granted to you in and to the Website and
                  Rushmyfood Content and Marks. If you download or print a copy of the Rushmyfood Content for personal
                  use, you must retain all copyright and other proprietary notices contained therein. You agree not to
                  circumvent, disable or otherwise interfere with security related features of the Website or features
                  that prevent or restrict use or copying of any Rushmyfood Content or enforce limitations on use of
                  the Website or the Rushmyfood Content therein.
                </P>
              </Section>

              <Section title="Third Party Websites and Content" classes={classes}>
                <P classes={classes}>
                  The Website contains (or you may be sent through the Website or the Rushmyfood Service) links to
                  other websites (“Third Party Websites”) as well as articles, photographs, text, graphics, pictures,
                  designs, music, sound, video, information, applications, software and other content or items
                  belonging to or originating from third parties (the “Third Party Content”). Such Third Party
                  Websites and Third Party Content are not investigated, monitored or checked for accuracy,
                  appropriateness, or completeness by us, and we are not responsible for any Third Party Websites
                  accessed through the Website or any Third Party Content posted on, available through or installed
                  from the Website, including the content, accuracy, offensiveness, opinions, reliability, privacy
                  practices or other policies of or contained in the Third Party Websites or the Third Party Content.
                  Inclusion of, linking to or permitting the use or installation of any Third Party Website or any
                  Third Party Content does not imply approval or endorsement thereof by us. If you decide to leave the
                  Website and access the Third Party Websites or to use or install any Third Party Content, you do so
                  at your own risk and you should be aware that our terms and policies no longer govern. You should
                  review the applicable terms and policies, including privacy and data gathering practices, of any
                  website to which you navigate from the Website or relating to any applications you use or install
                  from the Website. Any purchases you make through Third Party Websites will be through other
                  websites and from other companies, and Rushmyfood takes no responsibility whatsoever in relation to
                  such purchases which are exclusively between you and the applicable third party.
                </P>
              </Section>

              <Section title="Site Management" classes={classes}>
                <P classes={classes}>Rushmyfood reserves the right but does not have the obligation to:</P>
                <Bullets
                  classes={classes}
                  items={[
                    "monitor the Website for violations of this Agreement;",
                    "take appropriate legal action against anyone who, in Rushmyfood’s sole discretion, violates this Agreement, including without limitation, reporting such user to law enforcement authorities;",
                    "in Rushmyfood’s sole discretion and without limitation, refuse, restrict access to or availability of, or disable (to the extent technologically feasible) any user’s Contribution or any portion thereof that may violate this Agreement or any Rushmyfood policy;",
                    "in Rushmyfood’s sole discretion and without limitation, notice or liability to remove from the Website or otherwise disable all files and content that are excessive in size or are in any way burdensome to Rushmyfood’s systems;",
                    "terminate the accounts of repeat infringers; and",
                    "otherwise manage the Website in a manner designed to protect the rights and property of Rushmyfood and others and to facilitate the proper functioning of the Website.",
                  ]}
                />
              </Section>

              <Section title="Privacy" classes={classes}>
                <P classes={classes}>
                  We care about the privacy of our users. Please review the Rushmyfood Privacy Policy. By using the
                  Website or the Rushmyfood Services, you are consenting to have your personal data transferred to
                  and processed in the United States. By using the Website or the Rushmyfood Services, you are
                  consenting to the terms of Privacy Policy.
                </P>
              </Section>

              <Section title="Term and Termination" classes={classes}>
                <P classes={classes}>
                  This Agreement shall remain in full force and effect while you use the Website or are otherwise a
                  user of the Website. You may terminate your use or participation at any time, for any reason, by
                  following the instructions for terminating user accounts in your account settings.
                </P>
                <P classes={classes}>
                  WITHOUT LIMITING ANY OTHER PROVISION OF THIS AGREEMENT, RUSHMYFOOD RESERVES THE RIGHT TO, IN
                  RUSHMYFOOD’S SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE WEBSITE
                  AND THE RUSHMYFOOD SERVICES, TO ANY PERSON FOR ANY REASON OR FOR NO REASON AT ALL, INCLUDING WITHOUT
                  LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY OR COVENANT CONTAINED IN THIS AGREEMENT, OR OF
                  ANY APPLICABLE LAW OR REGULATION, AND RUSHMYFOOD MAY TERMINATE YOUR USE OR PARTICIPATION IN THE
                  WEBSITE AND THE RUSHMYFOOD SERVICES, DELETE YOUR PROFILE AND ANY CONTENT OR INFORMATION THAT YOU
                  HAVE POSTED AT ANY TIME, WITHOUT WARNING, IN RUSHMYFOOD’S SOLE DISCRETION.
                </P>
                <P classes={classes}>
                  In order to protect the integrity of the Website and Rushmyfood Services, Rushmyfood reserves the
                  right at any time in its sole discretion to block certain IP addresses from accessing the Website
                  Rushmyfood Services.
                </P>
                <P classes={classes}>
                  Any provisions of this Agreement that, in order to fulfill the purposes of such provisions, need to
                  survive the termination or expiration of this Agreement, shall be deemed to survive for as long as
                  necessary to fulfill such purposes.
                </P>
              </Section>

              <Section title="Modifications" classes={classes}>
                <Typography variant="subtitle2" className={classes.boldText} sx={{ mt: 1 }}>To Agreement</Typography>
                <P classes={classes}>
                  Rushmyfood may modify this Agreement from time to time. Any and all changes to this Agreement will
                  be reflected on the Website and revisions will be indicated by date. You agree to be bound to any
                  changes to this Agreement when you use the Rushmyfood Services after any such modification posted
                  on the Website becomes effective. Rushmyfood may also, in its discretion, choose to alert all users
                  with whom it maintains email information of such modifications by means of an email to their most
                  recently provided email address. It is therefore important that you regularly review this Agreement
                  and keep your contact information current in your account settings to ensure you are informed of
                  changes. Modifications to this Agreement shall be effective 30 days after being posted but shall
                  not apply retroactively. Additionally, modifications made to this Agreement applicable to dispute
                  resolution shall not apply to disputes arising prior to the effective date of the modification.
                </P>
                <Typography variant="subtitle2" className={classes.boldText} sx={{ mt: 2 }}>To Services</Typography>
                <P classes={classes}>
                  Rushmyfood reserves the right at any time to modify or discontinue, temporarily or permanently, the
                  Rushmyfood Services (or any part thereof) with or without notice. You agree that Rushmyfood shall
                  not be liable to you or to any third party for any modification, suspension or discontinuance of
                  the Rushmyfood Services.
                </P>
              </Section>

              <Section title="Disputes" classes={classes}>
                <Typography variant="subtitle2" className={classes.boldText} sx={{ mt: 1 }}>Between Users</Typography>
                <P classes={classes}>
                  If there is a dispute between users of the Website, or between users and any third party, you
                  understand and agree that Rushmyfood is under no obligation to become involved. In the event that
                  you have a dispute with one or more other users, you hereby release Rushmyfood, its officers,
                  employees, agents and successors in rights from claims, demands and damages (actual and
                  consequential) of every kind or nature, known or unknown, suspected and unsuspected, disclosed and
                  undisclosed, arising out of or in any way related to such disputes and/or the Rushmyfood Services.
                </P>
                <Typography variant="subtitle2" className={classes.boldText} sx={{ mt: 2 }}>With Rushmyfood</Typography>
                <P classes={classes}>
                  All questions of law, rights, and remedies regarding any act, event or occurrence undertaken
                  pursuant or relating to this Website or the Rushmyfood Services shall be governed and construed by
                  the law of the State of California, excluding such state’s conflicts of law rules. Any legal action
                  of whatever nature by or against Rushmyfood arising out of or related in any respect to this
                  Website and the Rushmyfood Services shall be brought solely in either the applicable federal or
                  state courts located in or with jurisdiction over San Francisco County, California; subject,
                  however, to the right of Rushmyfood, at Rushmyfood’s sole discretion, to bring an action to seek
                  injunctive relief to enforce this Agreement or to stop or prevent an infringement of proprietary or
                  other third party rights (or any similar cause of action) in any applicable court in any
                  jurisdiction where jurisdiction exists with regard to a user. You hereby consent to (and waive any
                  challenge or objection to) personal jurisdiction and venue in the above-referenced courts.
                  Application of the United Nations Convention on Contracts for the International Sale of Goods is
                  excluded from this Agreement. Additionally, application of the Uniform Computer Information
                  Transaction Act (UCITA) is excluded from this Agreement. In no event shall any claim, action or
                  proceeding by you related in any way to the Website and/or the Rushmyfood Service (including your
                  visit to or use of the Website and/or the Rushmyfood Service) be instituted more than two (2) years
                  after the cause of action arose.
                </P>
              </Section>

              <Section title="Corrections" classes={classes}>
                <P classes={classes}>
                  Occasionally there may be information on the Website that contains typographical errors,
                  inaccuracies or omissions that may relate to service descriptions, pricing, availability, and
                  various other information. Rushmyfood reserves the right to correct any errors, inaccuracies or
                  omissions and to change or update the information at any time, without prior notice.
                </P>
              </Section>

              <Section title="Disclaimers" classes={classes}>
                <P classes={classes}>
                  Rushmyfood cannot control the nature of all of the content available on the Website or food
                  products sold via the Website. By operating the Website, Rushmyfood does not represent or imply
                  that Rushmyfood endorses any sellers, sellers’ products, blogs, Contributions or other content or
                  products available on or linked to by the Website, including without limitation content hosted on
                  third party websites, or that Rushmyfood believes food products, Contributions, blogs or other
                  content to be accurate, useful or non-harmful. We do not control and are not responsible for
                  unlawful or otherwise objectionable products or content you may encounter on the Website or in
                  connection with any sellers or Contributions. Rushmyfood is not responsible for the conduct,
                  whether online or offline, of any user of the Website or Rushmyfood Services.
                </P>
                <P classes={classes}>
                  YOU AGREE THAT YOUR USE OF THE WEBSITE AND RUSHMYFOOD SERVICES WILL BE AT YOUR SOLE RISK. TO THE
                  FULLEST EXTENT PERMITTED BY LAW, RUSHMYFOOD, ITS OFFICERS, DIRECTORS, MEMBERS, EMPLOYEES, AND
                  AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE WEBSITE AND RUSHMYFOOD
                  SERVICES AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. RUSHMYFOOD MAKES NO
                  WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE WEBSITE’S CONTENT OR THE
                  CONTENT OF ANY WEBSITES LINKED TO THIS WEBSITE AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY
                  (A) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (B) PERSONAL INJURY OR PROPERTY
                  DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF OUR WEBSITE AND
                  RUSHMYFOOD SERVICES, (C) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
                  ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (D) ANY INTERRUPTION OR
                  CESSATION OF TRANSMISSION TO OR FROM THE WEBSITE, (E) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
                  LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY THIRD PARTY, AND/OR (F) ANY ERRORS
                  OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
                  RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE.
                  RUSHMYFOOD DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR
                  SERVICE ADVERTISED OR OFFERED THROUGH THE WEBSITE OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY
                  BANNER OR OTHER ADVERTISING, AND RUSHMYFOOD WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE
                  FOR MONITORING ANY TRANSACTION BETWEEN YOU AND PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE
                  PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR
                  BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
                </P>
              </Section>

              <Section title="Limitations of Liability" classes={classes}>
                <P classes={classes}>
                  IN NO EVENT SHALL RUSHMYFOOD OR ITS DIRECTORS, MEMBERS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR
                  ANY THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL OR PUNITIVE
                  DAMAGES, INCLUDING LOST PROFIT DAMAGES ARISING FROM YOUR USE OF THE WEBSITE OR RUSHMYFOOD
                  SERVICES, EVEN IF RUSHMYFOOD HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING
                  ANYTHING TO THE CONTRARY CONTAINED HEREIN, RUSHMYFOOD’S LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER
                  AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY,
                  BY YOU TO RUSHMYFOOD FOR RUSHMYFOOD SERVICES DURING THE PERIOD OF 1 MONTH PRIOR TO ANY CAUSE OF
                  ACTION ARISING.
                </P>
                <P classes={classes}>
                  CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION
                  OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR
                  LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.
                </P>
                <P classes={classes}>
                  IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE SECTION 1542, WHICH SAYS: “A
                  GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN
                  HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH, IF KNOWN BY HIM MUST HAVE MATERIALLY
                  AFFECTED HIS SETTLEMENT WITH THE DEBTOR.”
                </P>
              </Section>

              <Section title="Contact Us" classes={classes}>
                <P classes={classes}>
                  In order to resolve a complaint regarding Rushmyfood Services or to receive further information
                  regarding use of Rushmyfood Services, please contact us by Email at
                  info@Rushmyfood.com
                </P>
              </Section>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default React.memo(Terms);
